export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyCltblS9EfzcbgJmlpA0u3jfdbVTAlW8fQ",
    authDomain: "dirtytalk-45997.firebaseapp.com",
    databaseURL: "https://dirtytalk-45997.firebaseio.com",
    projectId: "dirtytalk-45997",
    storageBucket: "dirtytalk-45997.appspot.com",
    messagingSenderId: "213792333643"
  };


// WEBPACK FOOTER //
// ./src/app/app.environment.config.ts